const user = {
    keyId: ['user'] as const,
    getMe: () => [...user.keyId, 'getMe'] as const,
    getMyPermission: () => [...user.keyId, 'getMyPermission'] as const,
    getUsers: () => [...user.keyId, 'getUsers'] as const,
    getUserDetail: (userID?: number) => [...user.keyId, 'getUserDetail', userID] as const,
    getUserRecentState: (userID?: number) => [...user.keyId, 'getUserRecentState', userID] as const,
    getUserStatAverage: (userID?: number) => [...user.keyId, 'getUserStatAverage', userID] as const,
    getUserCharts: (userID?: number) => [...user.keyId, 'getUserCharts', userID] as const,
    getUserCharts10Minutes: (userID?: number) => [...user.keyId, 'getUserCharts10Minutes', userID] as const,
    getUserDailyPosition: (userID?: number, date?: string) =>
        [...user.keyId, 'getUserDailyPosition', userID, date] as const,
    getUsersSimple: () => [...user.keyId, 'getUsersSimple'] as const
}

const settings = {
    keyId: ['settings'] as const,
    getSettings: () => [...settings.keyId, 'getSettings'] as const,
}

const notification = {
    keyId: ['notification'] as const,
    getAlertBioToday: () => [...notification.keyId, 'getAlertBioToday'] as const,
    getAlertBioLive: () => [...notification.keyId, 'getAlertBioLive'] as const,

    getEmergencyAlertToday: () => [...notification.keyId, 'getEmergencyAlertToday'] as const,
    getEmergencyAlertLive: () => [...notification.keyId, 'getEmergencyAlertLive'] as const,

    getFalldetectionAlertToday: () => [...notification.keyId, 'getFalldetectionAlertToday'] as const,
    getFalldetectionAlertLive: () => [...notification.keyId, 'getFalldetectionAlertLive'] as const,

    getAlertBioDetail: (id?: number) => [...notification.keyId, 'getAlertBioDetail', id] as const,
    getAlertEmergencyDetail: (id?: number) => [...notification.keyId, 'getAlertEmergencyDetail', id] as const,
    getAlertFalldetectionDetail: (id?: number) => [...notification.keyId, 'getAlertFalldetectionDetail', id] as const,

    apiGetNotificationBio: (query?: string) => [...notification.keyId, 'apiGetNotificationBio', query] as const,
    apiGetNotificationSos: (query?: string) => [...notification.keyId, 'apiGetNotificationSos', query] as const,
    apiGetNotificationFalldetection: (query?: string) => [...notification.keyId, 'apiGetNotificationFalldetection', query] as const,

    getUrgentNotification: () => [...notification.keyId, 'getUrgentNotification'] as const,
    getUrgentNotificationHistory: () => [...notification.keyId, 'getUrgentNotificationHistory'] as const
}

const alerts = {
    keyId: ['alerts'] as const,
    unprocessed: () => [...alerts.keyId, 'unprocessed'] as const,
    safeZoneStatus: () => [...alerts.keyId, 'safeZoneStatus'] as const,
};

const mentalHealth = {
    keyId: ['mentalHealth'] as const,
    getDashboard: () => [...mentalHealth.keyId, 'dashboard'] as const,
    getReports: (params?: any) => [...mentalHealth.keyId, 'reports', params] as const,
    getReportDetail: (id?: number) => [...mentalHealth.keyId, 'reports', 'detail', id] as const,
    uploadBCG: () => [...mentalHealth.keyId, 'uploadBCG'] as const,
    getSessions: (protecteeId: number, params?: any) => [...mentalHealth.keyId, 'sessions', protecteeId, params] as const,
    getSession: (protecteeId: number, sessionId: string) => [...mentalHealth.keyId, 'session', protecteeId, sessionId] as const,
    getSessionBCGData: (protecteeId: number, sessionId: string) => [...mentalHealth.keyId, 'sessionBCGData', protecteeId, sessionId] as const
}

export const QueryCacheKeys = {
    user,
    settings,
    notification,
    alerts,
    mentalHealth
};
